import { useEffect, useState } from "react";

// ui
import { Box, Alert, Typography, IconButton, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Table
import TableTopBar from "../component/TableTopBar";
import { ConstTable } from "../component/Table";
import { EmptyState } from "../component/EmptyState";
import { DataDetailTable } from "../component/detail/DataDetailTable";

// Bar
import { SerchSideBar } from "../component/SerchSideBar";

// Modal
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";
import { FollowCallConfigCopyModal } from "../component/tableFunction/FollowCallConfigCopyModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getFollowCallConfigs,
  getFollowCallConfig,
  postFollowCallConfig,
  putFollowCallConfig,
  deleteFollowCallConfig,
  copyFollowCallConfig,
} from "../api/followCallConfig";
import {
  getFollowCallConfigServices,
  postFollowCallConfigServices,
} from "../api/followCallConfigService";
import {
  getFollowCallConfigEntrySaleCompanys,
  postFollowCallConfigEntrySaleCompanys,
} from "../api/followCallConfigEntrySaleCompany";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
} from "../api/serch";

// InterFace
import { followCallConfigTableColumn } from "../config/followCallConfig";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";
import {
  isTableFunctionDisabled,
  detailToFacts,
} from "../component/tableFunctionRules";

function FollowCallConfig() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const setDetailBreadcrumb = useSetAtom(AppAtoms.detailBreadcrumb);
  const [detailView, setDetailView] = useState<boolean>(false);
  const [sortColumn, setSortColumn] = useState<{ key: string; sort: string }[]>(
    [],
  );

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "フォローコール設定登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "フォローコール設定登録") {
      setAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {}, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "サービス一覧") {
      getSubtableDataService();
    }
    if (getSubTableName.name === "エントリーパートナー一覧") {
      getSubtableDataEntrySaleCompany();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {}, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "サービス追加") {
      openModalSubtableDataAddService();
    }
    if (getSubTableAdd.name === "エントリーパートナー追加") {
      openModalSubtableDataAddEntrySaleCompany();
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "コピー") {
      setCopyDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
        follow_call_entry_status_conf: null,
        follow_call_entry_status: "",
        follow_call_base_day_conf: null,
        follow_call_day_offset: null,
      });
    }
    if (tableOriginalFunc.name === "削除") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  const [serchOpen, setSerchOpen] = useState(false);
  const aiChatOpen = useAtomValue(AppAtoms.aiChatOpen);
  const setAiChatOpenAtom = useSetAtom(AppAtoms.aiChatOpen);
  // cmd-po_1168 SP排他: AI open時に検索を close
  useEffect(() => {
    if (aiChatOpen && isSmartPhone) setSerchOpen(false);
  }, [aiChatOpen, isSmartPhone]);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open && isSmartPhone) setAiChatOpenAtom(false);
  };

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = followCallConfigTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
            no_entry_flg: "通常",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
            no_entry_flg: "通常",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
            no_entry_flg: "通常",
          };
        }
      } else {
        return {
          ...column,
          no_entry_flg: "通常",
        };
      }
    },
    {},
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getFollowCallConfigs({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.followCallConfigs);
      const countFollowCallConfigs = Number(fetchData.countFollowCallConfigs);
      setTotalCount(countFollowCallConfigs);
      setMaxPageNumber(Math.ceil(countFollowCallConfigs / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 商材詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  function closeDetailView() {
    setDetailView(false);
    setDataDetail(null);
    setDetailBreadcrumb(null);
  }

  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getFollowCallConfig(id);
    setDataDetail(dataDetail);
    if (!edit) {
      setDetailView(true);
      setDetailBreadcrumb({
        crumb: "各種設定 / フォローコール設定 / ",
        title: "フォローコール設定詳細",
      });
      setIsLoading(false);
    }
  }
  // 商材編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putFollowCallConfig(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 商材新規作成
  const addDataColumns = followCallConfigTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (difine.key === "payment_method") {
          return {
            ...column,
            [difine.key]: [""],
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addData, setAddData] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onAddModal, setAddModal] = useState(false);

  async function postAddData() {
    setIsLoading(true);
    setAddModal(false);
    const postResponce = await postFollowCallConfig(addData);
    if (postResponce === "success") {
      await getTableData(true);
      setAddData(addDataColumns);
      setOnDataAddModalResult("success");
    } else {
      setAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // データコピー
  const [copyDataInf, setCopyDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_entry_status_conf: number | null;
    follow_call_entry_status: string;
    follow_call_base_day_conf: number | null;
    follow_call_day_offset: number | null;
  }>({
    status: null,
    key: {},
    message: "",
    follow_call_entry_status_conf: null,
    follow_call_entry_status: "",
    follow_call_base_day_conf: null,
    follow_call_day_offset: null,
  });
  async function copyData() {
    setCopyDataInf({
      ...copyDataInf,
      status: "loading",
    });
    const id = copyDataInf.key.id;
    const responce = await copyFollowCallConfig(
      id,
      copyDataInf.follow_call_entry_status_conf,
      copyDataInf.follow_call_entry_status,
      copyDataInf.follow_call_base_day_conf,
      copyDataInf.follow_call_day_offset,
    );
    if (responce == "success") {
      await getTableData(false);
      setCopyDataInf({
        ...copyDataInf,
        status: "success",
      });
    } else {
      setCopyDataInf({
        ...copyDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (copyDataInf.status === "loading") {
      setIsLoading(true);
    } else if (copyDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [copyDataInf]);

  // データ削除
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteFollowCallConfig(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // サービス一覧取得
  async function getSubtableDataService() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getFollowCallConfigServices(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // サービス登録
  const [addDataService, setAddDataService] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    follow_call_config_id: "",
    all_service: [],
    select_service: [],
  });
  const [onDataAddModalService, setOnDataAddModalService] = useState(false);
  async function openModalSubtableDataAddService() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getFollowCallConfigServices(
        getSubTableAdd.row.id as string,
      );
      setAddDataService({
        follow_call_config_id: getSubTableAdd.row.id as string,
        all_service: fetchData.serviceDatas,
        select_service: fetchData.sudDatas,
      });
      setOnDataAddModalService(true);
      setIsLoading(false);
    }
  }
  async function postAddDataService() {
    setIsLoading(true);
    setOnDataAddModalService(false);
    const postResponce = await postFollowCallConfigServices(addDataService);
    if (postResponce === "success") {
      if (getSubTableName.name == "サービス一覧") {
        await getSubtableDataService();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataService({
        follow_call_config_id: "",
        all_service: [],
        select_service: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalService(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // エントリーパートナー一覧取得
  async function getSubtableDataEntrySaleCompany() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getFollowCallConfigEntrySaleCompanys(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリーパートナー登録
  const [addDataEntrySaleCompany, setAddDataEntrySaleCompany] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    follow_call_config_id: "",
    all_entry_sale_company: [],
    select_entry_sale_company: [],
  });
  const [onDataAddModalEntrySaleCompany, setOnDataAddModalEntrySaleCompany] =
    useState(false);
  async function openModalSubtableDataAddEntrySaleCompany() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getFollowCallConfigEntrySaleCompanys(
        getSubTableAdd.row.id as string,
      );
      setAddDataEntrySaleCompany({
        follow_call_config_id: getSubTableAdd.row.id as string,
        all_entry_sale_company: fetchData.entrySaleCompanyData,
        select_entry_sale_company: fetchData.sudDatas,
      });
      setOnDataAddModalEntrySaleCompany(true);
      setIsLoading(false);
    }
  }
  async function postAddDataEntrySaleCompany() {
    setIsLoading(true);
    setOnDataAddModalEntrySaleCompany(false);
    const postResponce = await postFollowCallConfigEntrySaleCompanys(
      addDataEntrySaleCompany,
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "エントリーパートナー一覧") {
        await getSubtableDataEntrySaleCompany();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataEntrySaleCompany({
        follow_call_config_id: "",
        all_entry_sale_company: [],
        select_entry_sale_company: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalEntrySaleCompany(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // パートナー一覧（検索用）
  const [companyNameList, setCompanyNameList] = useState<string[]>([""]);
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCompanyNameList([""]);
    } else if (fetchData?.saleCompanys) {
      const nameList = [""];
      fetchData.saleCompanys.forEach(
        (c: { id: number; sale_company_name: string }) => {
          if (!nameList.includes(c.sale_company_name)) {
            nameList.push(c.sale_company_name);
          }
        },
      );
      setCompanyNameList(nameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[],
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        },
      );
      setProductNameList(productNameList);
    }
  }
  // サービス新規登録時、選択した上位店により商材一覧
  const [selectProductList, setSelectProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  useEffect(() => {
    let selectProductList: {
      id: number;
      high_rank_company_id: number;
      product_name: string;
    }[] = [];
    const high_rank_company_id = Number(addData.high_rank_company_id);
    productList.map((product) => {
      if (product.high_rank_company_id === high_rank_company_id) {
        selectProductList.push(product);
      }
    });
    setSelectProductList(selectProductList);
  }, [addData]);

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getSaleCompanysList();
  }, []);

  return (
    <Box
      data-testid="follow-call-config-page"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "var(--sp-2, 8px)",
          alignItems: "stretch",
          flex: 1,
          minHeight: 0,
        }}
      >
        {detailView && dataDetail ? (
          /* ─── 詳細ページビュー ─── */
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              maxHeight: "100%",
            }}
          >
            <Box
              data-testid="detail-header"
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                flexWrap: "wrap",
                gap: 1,
                flexShrink: 0,
              }}
            >
              <IconButton
                size="small"
                onClick={closeDetailView}
                aria-label="一覧に戻る"
                sx={{ mr: 0.5 }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, fontSize: 20, color: "text.primary" }}
              >
                {dataDetail["high_rank_company_name"] as string} /{" "}
                {dataDetail["product_name"] as string}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 2,
                p: "10px 16px",
                border: "1px solid var(--color-border, #e5e5e0)",
                borderRadius: "var(--radius-md, 10px)",
                bgcolor: "background.paper",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mr: 1, fontSize: 13 }}
              >
                今押せる操作
              </Typography>
              {(() => {
                const facts = detailToFacts(dataDetail);
                const ctx = { pathname: "/follow_call_config" };
                return followCallConfigTableColumn.tableFunction
                  .filter(
                    (tf) =>
                      loginUser &&
                      tf.auth.includes(loginUser.authority) &&
                      tf.displayScope !== "detail_only",
                  )
                  .map((tf) => (
                    <Button
                      key={tf.name}
                      variant="outlined"
                      size="small"
                      color={tf.name === "削除" ? "error" : "primary"}
                      disabled={isTableFunctionDisabled(tf.name, facts, ctx)}
                      sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                      onClick={() =>
                        setTableOriginalFunc({
                          name: tf.name,
                          key: { id: String(dataDetail["id"]) },
                        })
                      }
                    >
                      {tf.name}
                    </Button>
                  ));
              })()}
            </Box>
            <DataDetailTable
              editAuth={followCallConfigTableColumn.editAuth}
              dataColumn={followCallConfigTableColumn.dataColumn}
              subDataColumn={[]}
              dataDetail={dataDetail}
              setEditData={setEditData}
              dataDetailOption={[]}
              dataDetailOptionSelect={[]}
              dataDetailHistory={[]}
              detailTitle={followCallConfigTableColumn.detailTitle}
              getGroupList={() => {}}
              setSelectServiseInfo={() => {}}
              setSelectTossUpInfo={() => {}}
            />
          </Box>
        ) : (
          <>
            {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  maxHeight: "100%",
                }}
              >
                <TableTopBar
                  serch={true}
                  serchOpen={serchOpen}
                  setSerchOpen={handleSetSerchOpen}
                  addDataNames={addDataNames}
                  addDataName={addDataName}
                  setAddDataName={setAddDataName}
                  addCSVDataNames={addCSVDataNames}
                  addCSVDataName={addCSVDataName}
                  setAddCSVDataName={setAddCSVDataName}
                  getXLSXDataNames={getXLSXDataNames}
                  getXLSXDataName={getXLSXDataName}
                  setGetXLSXDataName={setGetXLSXDataName}
                  editDatasNames={editDatasNames}
                  editDatasName={editDatasName}
                  setEditDatasName={setEditDatasName}
                  editIDs={[]}
                  columnSettingOpen={false}
                  openColumnSettingWindow={() => {}}
                    totalCount={totalCount}
                  onReload={() => getTableData(false)}
                />
                <ConstTable
                  emptyState={
                    <EmptyState
                      isSearchActive={Object.keys(serchString).some(
                        (k) =>
                          (serchString as Record<string, string>)[k] !==
                          (serchColumn as Record<string, string>)[k],
                      )}
                      onClearSearch={() => {
                        setSerchString(serchColumn);
                        setSerchStringView(serchColumn);
                      }}
                      canAdd={addDataNames.includes("フォローコール設定登録")}
                      onAdd={() => setAddDataName("フォローコール設定登録")}
                      entityLabel="フォローコール設定"
                    />
                  }
                  getTableData={getTableData}
                  tableType={"main"}
                  serch={true}
                  setSerchOpen={handleSetSerchOpen}
                  serchOpen={serchOpen}
                  tableColumn={followCallConfigTableColumn}
                  dataColumn={[]}
                  rows={fetchData}
                  displayNumber={displayNumber}
                  setDisplayNumber={setDisplayNumber}
                  displayNumbers={displayNumbers}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  maxPageNumber={maxPageNumber}
                  totalCount={totalCount}
                  getDataDetail={getDataDetail}
                  getSubTableName={getSubTableName}
                  setGetSubTableName={setGetSubTableName}
                  getSubTableDetail={getSubTableDetail}
                  setGetSubTableDetail={setGetSubTableDetail}
                  setGetSubTableAdd={setGetSubTableAdd}
                  setGetSubTableEditDirect={() => {}}
                  getSubSubTableName={getSubSubTableName}
                  setGetSubSubTableName={setGetSubSubTableName}
                  getSubSubTableDetail={{ name: "", key: {}, dataDetail: null }}
                  setGetSubSubTableDetail={() => {}}
                  setGetSubSubTableAdd={setGetSubSubTableAdd}
                  setGetSubSubTableEditDirect={() => {}}
                  tableTitle={followCallConfigTableColumn.title}
                  switchTableCheckBox={() => {}}
                  allCheckFlg={false}
                  switchAllTableCheckBox={() => {}}
                  editIDs={[]}
                  setEditIDs={() => {}}
                  setEditDatasName={setEditDatasName}
                  setTableOriginalFunc={setTableOriginalFunc}
                  sortColumn={sortColumn}
                  setSortColumn={setSortColumn}
                />
              </Box>
            )}
            {serchOpen ? (
              <SerchSideBar
                setSerchOpen={handleSetSerchOpen}
                tableColumn={followCallConfigTableColumn}
                dataColumn={[]}
                firstYear={firstYear}
                thisYear={thisYear}
                serchColumn={serchColumn}
                setSerchString={setSerchString}
                companyNameList={companyNameList}
                companyGroupNameList={[]}
                highRankCompanyNameList={highRankCompanyNameList}
                categoryNameList={categoryNameList}
                productNameList={productNameList}
                accountSaleNameList={[]}
                accountStaffNameList={[]}
                serchStringView={serchStringView}
                setSerchStringView={setSerchStringView}
              />
            ) : null}
          </>
        )}
      </Box>
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={categoryList}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onAddModal}
        swCloseModal={() => {
          setAddModal(false);
          setAddDataName("");
        }}
        addTitle={followCallConfigTableColumn.addTitle}
        dataColumn={followCallConfigTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        companyList={[]}
        highRankCompanyList={highRankCompanyList}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={categoryList}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataAddModal
        onModal={onDataAddModalService}
        swCloseModal={() => {
          setOnDataAddModalService(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={followCallConfigTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={followCallConfigTableColumn.subTable[0].subDataColumn}
        postAddData={postAddDataService}
        addData={addDataService}
        setAddData={setAddDataService}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalEntrySaleCompany}
        swCloseModal={() => {
          setOnDataAddModalEntrySaleCompany(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={followCallConfigTableColumn.subTable[1].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={followCallConfigTableColumn.subTable[1].subDataColumn}
        postAddData={postAddDataEntrySaleCompany}
        addData={addDataEntrySaleCompany}
        setAddData={setAddDataEntrySaleCompany}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <DataDeleteModal
        onModal={
          deleteDataInf.status !== null && deleteDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteDataInf}
        setDeleteDataInf={setDeleteDataInf}
        deleteData={deleteData}
        labels={{
          title: "フォローコール設定削除",
          confirmBody: (
            <Alert severity="error">
              フォローコール設定削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "設定削除",
          successMessage: "フォローコール設定の削除に成功しました。",
        }}
      />
      <FollowCallConfigCopyModal
        onModal={
          copyDataInf.status !== null && copyDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setCopyDataInf({
            status: null,
            key: {},
            message: "",
            follow_call_entry_status_conf: null,
            follow_call_entry_status: "",
            follow_call_base_day_conf: null,
            follow_call_day_offset: null,
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        copyDataInf={copyDataInf}
        setCopyDataInf={setCopyDataInf}
        copyData={copyData}
      />
    </Box>
  );
}

export default FollowCallConfig;
